import {createRouter, createWebHashHistory} from "vue-router"
import storage from "@/storage/storage"
import { checkRoutePermission, loadUserPermissions } from "@/util/permission"
import { ElMessage } from "element-plus"

const routes = [
    {
        path:"/",
        name:'root',
        redirect:"/homePage",
        component:() => import("@/view/layout/layout.vue"),
        children:[
            {
                path:'homePage',
                name: '/homePage',
                component: () => import("@/view/home/home.vue")
            }
        ]
    }
    ,{
        path:'/login',
        component: () => import("@/view/login/login.vue")
    },
    {
        path:'/no-permission',
        component: () => import("@/view/error/noPermission.vue")
    }
]
const router = createRouter({
    history:new createWebHashHistory('/'),
    routes
})

// 标记动态路由是否已加载完成（供其他模块参考，路由守卫不依赖此标记）
let dynamicRoutesLoaded = false

export const setDynamicRoutesLoaded = (loaded) => {
    dynamicRoutesLoaded = loaded
}

// 权限加载标记
let permissionsLoaded = false

router.beforeEach(async (to, from, next) => {
    const user = storage.ls.get("user")
    // 没有登录且目标不是登录页，跳转到登录页
    if(user == null && to.path !== '/login') {
        next('/login')
        return
    }
    
    // 如果已登录但权限未加载，加载权限
    if (user != null && !permissionsLoaded) {
        await loadUserPermissions()
        permissionsLoaded = true
    }
    
    // 检查路由权限
    if (to.path !== '/login' && to.path !== '/no-permission') {
        // 获取当前路由及其所有父路由
        const matchedRoutes = to.matched
        for (const route of matchedRoutes) {
            if (route.meta && route.meta.permissions) {
                if (!checkRoutePermission(route)) {
                    ElMessage.error('您没有访问此页面的权限')
                    next('/no-permission')
                    return
                }
            }
        }
    }
    
    next()
})

// 登录成功后调用此函数重置权限加载状态
export const resetPermissionsLoaded = () => {
    permissionsLoaded = false
}

export default router
